import { useState } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={styles.notFoundContainer}>
      <h1 style={styles.errorCode}>404: Not Found!</h1>
      <p style={styles.errorMessage}>
        Oops! The page you're looking for doesn't exist.
      </p>
      <button
        style={{ ...styles.homeButton, ...(isHovered ? hoverStyle : {}) }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => navigate("/")}
      >
        Go Home
      </button>
    </div>
  );
};

export default NotFound;

// Styles
const styles = {
  notFoundContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
  },
  errorCode: {
    fontSize: "80px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  errorMessage: {
    fontSize: "20px",
    color: "#555",
    marginBottom: "20px",
  },
  homeButton: {
    position: 'relative',
    padding: "10px 20px",
    fontSize: "18px",
    color: "#fff",
    backgroundColor: "#535353",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s, color 0.3s",
  },
};

// Hover effect
const hoverStyle = {
  backgroundColor: "#fff",
  color: "#535353",
  border: "2px solid #535353",
};
